import { Input, TabMenuItem, TnModal, ContextMenu, IconButton, ContextMenuModal, MenuList, MenuItem } from "bimui"
import { ReactComponent as CreateSvg } from 'bimui/dist/c1/icons/create.svg';
import { ReactComponent as FilterSvg } from 'bimui/dist/c1/icons/filter.svg';
import './file-index.less';
import { useEffect, useState, useRef } from 'react';
import FileItem from './file-item';
import { addFileList, deleteFileByUuidList, findFileByUuid, findFileListByParentUuidList, getFilePathByFileUuid } from "@/declare/api/project/file";
import { File } from "@/declare/interface/project/file"
import { useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import { floatVerification, nonNegativeIntegerVerification } from "@/utils/antd-input";
import { BaseUtils } from "tnbase";
import dayjs from 'dayjs';
import { FileType, FileTypeList } from "@/declare/enums/file-type";
import { User } from "@/declare/interface/project/user";
import localStore from "@/store/local-store";
import { emitter } from "@/utils/mitt";
import { Emit_Event_Common_Tool } from "@/declare/enums/emit-event";
import { SIDEBAR_TYPE } from "@/declare/enums/menu-type";


interface IProps {
    activeFile: File
    users: User[]
    searchInput: string,
    searchValue: string
    generateParentData: (deleteOrigin: boolean) => void // 是否删除了自身
    setActiveFile: (file: File) => void
    openFile: (file: File) => void
    onChangeSelected: (fileUuids: string[]) => void // 选择集改变
}

const SortType = {
    NONE: 1,     // 无 
    SORT: 2,     // 正序
    REVERSE: 3   // 倒序
}

export default function FileTable(props: IProps) {

    const { activeFile, users, searchValue, generateParentData, setActiveFile, openFile } = props

    const navigate = useNavigate();
    const { projectUuid } = useParams();
    /**
     * 文件列表
     */
    const [files, setFiles] = useState<File[]>([]);
    /**
     * 筛选后显示的文件列表
     */
    const [showFiles, setShowFiles] = useState<File[]>([])
    /**
     * 批量添加任务的数量
     */
    const [multiCreateNum, setMultiCreateNum] = useState<string>('');
    /**
    * 控制类型筛选弹窗的显示状态
    */
    const [typeFilterMenuVisible, setTypeFilterMenuVisible] = useState<boolean>(false);
    /**
     * 类型筛选弹窗的左侧位置
     */
    const [typeFilterMenuLeft, setTypeFilterMenuLeft] = useState<number>(0);
    /**
     * 类型筛选弹窗的顶部位置
     */
    const [typeFilterMenuTop, setTypeFilterMenuTop] = useState<number>(0);
    /**
     * 文件类型筛选
     */
    const [fileTypesFilter, setFileTypesFilter] = useState<number[]>([
        FileType.DRAWING, FileType.IMAGE, FileType.MODEL_FUNCTION, FileType.MODEL_PHYSICS, FileType.REPORT
    ]);
    /**
    * 控制执行人筛选弹窗的显示状态
    */
    const [userFilterMenuVisible, setUserFilterMenuVisible] = useState<boolean>(false);
    /**
     * 类型执行人弹窗的左侧位置
     */
    const [userFilterMenuLeft, setUserFilterMenuLeft] = useState<number>(0);
    /**
     * 类型执行人弹窗的顶部位置
     */
    const [userFilterMenuTop, setUserFilterMenuTop] = useState<number>(0);
    /**
     * 执行人类型筛选
     */
    const [fileUserFilter, setFileUserFilter] = useState<string[]>([]);
    /**
     * 控制右键菜单是否显示
     */
    const [cmOpen, setCmOpen] = useState<boolean>(false);
    /**
     * 右键菜单的纵坐标位置
     */
    const [cmTop, setCmTop] = useState<number>();
    /**
     * 右键菜单的横坐标位置
     */
    const [cmLeft, setCmLeft] = useState<number>();
    /**
     * 激活的文件的uuid列表
     */
    const [activeList, setActiveList] = useState<string[]>()
    /**
     * 用户名排序
     */
    const [sortUser, setSortUser] = useState<number>(SortType.NONE)
    /**
     * 更新时间排序
     */
    const [sortTime, setSortTime] = useState<number>(SortType.NONE)
    /**
     * 大小排序
     */
    const [sortSize, setSortSize] = useState<number>(SortType.NONE)
    /**
     * 任务名排序
     */
    const [sortName, setSortName] = useState<number>(SortType.NONE)

    /**
     * 删除事件的uuid
     */
    const [eventDeleteUuid, setEventDeleteUuid] = useState<number>(1); // 事件删除的uuid
    const eventDeleteUuidRef = useRef(eventDeleteUuid);
    /**
     * 编辑事件的uuid
     */
    const [eventEditUuid, setEventEditUuid] = useState<number>(1); // 事件复制的uuid
    const eventEditUuidRef = useRef(eventEditUuid);

    /**
     * 当前右键重命名的条目
     */
    const [editingUuid, setEditingUuid] = useState<string>();

    useEffect(() => {
        if (!props.activeFile) {
            setActiveList([]);
            return;
        }
        let status = localStore.getSidebarStatus(SIDEBAR_TYPE.FILE);
        setActiveList(status['activeList'] || []);
    }, [props.activeFile])

    const updateStatus = (activeList: any) => {
        const oldStatus = localStore.getSidebarStatus(SIDEBAR_TYPE.FILE);
        // 在这里向外传递状态
        let status = {
            ...oldStatus,
            activeList: activeList,
        };
        localStore.setSidebarStatus(SIDEBAR_TYPE.FILE, status);
    }

    useEffect(() => {
        emitter.on(Emit_Event_Common_Tool.DELETE, onListenDelete);
        emitter.on(Emit_Event_Common_Tool.EDIT, onListenEdit);

        return () => {
            emitter.off(Emit_Event_Common_Tool.DELETE, onListenDelete);
            emitter.off(Emit_Event_Common_Tool.EDIT, onListenEdit);
        };
    }, [])

    // 监听删除
    const onListenDelete = () => {
        setEventDeleteUuid(eventDeleteUuidRef.current + 1);
    }

    // 监听编辑
    const onListenEdit = () => {
        setEventEditUuid(eventEditUuidRef.current + 1);
    }

    useEffect(() => {
        eventDeleteUuidRef.current = eventDeleteUuid;
        if ((activeList || []).length == 0 || eventDeleteUuid == 1) {
            // 没有选中的条目
            // 删除uuid为初始值，不删除
            return;
        }
        onClickMenuDelete();
    }, [eventDeleteUuid])

    useEffect(() => {
        eventEditUuidRef.current = eventEditUuid;
        if ((activeList || []).length == 0 || eventEditUuid == 1) {
            // 没有选中的条目
            return;
        }
        // 编辑第一个选中的条目
        let firstFileUuid = activeList[0]
        let activeFile = showFiles.find(item => item.uuid == firstFileUuid);
        onDoubleClick(activeFile);
    }, [eventEditUuid])

    /**
     * 选择集改变，通知导航栏
     */
    useEffect(() => {
        props.onChangeSelected(activeList)
    }, [activeList])

    useEffect(() => {
        // setActiveList([])
        // updateStatus([])
        if (!props.activeFile) {
            setFiles([])
            setShowFiles([])
            return
        };
        generateData();
    }, [props.activeFile])

    // 初始化用户筛选
    useEffect(() => {
        if (!users) return
        let filterUser = []
        for (let i = 0; i < users.length; i++) {
            filterUser.push(users[i].uuid)
        }
        setFileUserFilter([...filterUser])
    }, [users])

    useEffect(() => {
        if (!fileTypesFilter || !fileUserFilter) {
            setShowFiles([...files])
            return;
        }
        let originFile = [...files]
        if (fileUserFilter.length != users.length) {
            originFile = originFile.filter(file => fileUserFilter.includes(file.userUuid))
        }
        originFile = originFile.filter(file => fileTypesFilter.includes(file.type))

        // 以下排序
        // 排序逻辑
        originFile.sort((a, b) => {
            // 默认比较结果为0，保持原序
            let compareResult = 0;

            // 根据不同排序字段进行排序
            if (sortName !== SortType.NONE) {
                if (sortName === SortType.SORT) {
                    compareResult = a.name.localeCompare(b.name); // 按名称升序排序
                } else if (sortName === SortType.REVERSE) {
                    compareResult = b.name.localeCompare(a.name); // 按名称降序排序
                }
            } else if (sortUser !== SortType.NONE) {
                if (sortUser === SortType.SORT) {
                    compareResult = a?.userName?.localeCompare(b?.userName); // 按用户升序排序
                } else if (sortUser === SortType.REVERSE) {
                    compareResult = b?.userName?.localeCompare(a?.userName); // 按用户降序排序
                }
            } else if (sortSize !== SortType.NONE) {
                if (sortSize === SortType.SORT) {
                    compareResult = a?.fileSize - b?.fileSize; // 按大小升序排序
                } else if (sortSize === SortType.REVERSE) {
                    compareResult = b?.fileSize - a?.fileSize; // 按大小降序排序
                }
            } else if (sortTime !== SortType.NONE) {
                if (sortTime === SortType.SORT) {
                    compareResult = a.gmtCreate - b.gmtCreate; // 按时间升序排序
                } else if (sortTime === SortType.REVERSE) {
                    compareResult = b.gmtCreate - a.gmtCreate; // 按时间降序排序
                }
            }

            return compareResult;
        });

        if (searchValue?.length > 0) {
            originFile = originFile.filter(item => item.name.match(searchValue)) || [];
        }

        setShowFiles([...originFile])

    }, [files, fileUserFilter, fileTypesFilter, sortName, sortSize, sortTime, sortUser, searchValue])

    /**
     * 获取数据
     */
    const generateData = () => {
        if (activeFile.type != FileType.MODEL_PHYSICS) {
            findFileListByParentUuidList(projectUuid, props.activeFile?.uuid).then(res => {
                let data: File[] = res.data || [];
                setFiles(data);
                // setShowFiles(data)
            }).catch(err => {
                console.log('err', err)
                message.error("获取文件列表失败");
            })
        } else {
            let fileList: File[] = []
            findFileByUuid(props.activeFile.uuid).then(res => {
                let activeFile: File = res.data
                fileList.push(activeFile)
                return findFileListByParentUuidList(projectUuid, props.activeFile?.uuid)
            }).then(res => {
                let data: File[] = res.data || [];
                fileList.push(...data)
                setFiles(fileList);
                // setShowFiles(fileList)
            }).catch(err => {
                console.log('err', err)
                message.error("获取文件列表失败");
            })
        }
    }

    const multiCreateFile = () => {
        if (!props.activeFile) return;
        let num = 1;
        let famortNum = floatVerification(multiCreateNum);
        if (!famortNum) {
            num = 1;
        } else if (Number(famortNum) <= 0) {
            message.info("创建任务数不能小于0");
            return;
        } else {
            num = Number(famortNum);
        }
        let parList = [];
        let gmt = dayjs().valueOf();
        let type = FileType.MODEL_PHYSICS
        for (let i = 0; i < num; i++) {
            let par: File = {
                projectUuid: projectUuid,
                parentUuid: props.activeFile?.uuid,
                name: `新建任务${i + 1}`,
                uuid: BaseUtils.genUUID(),
                gmtCreate: gmt,
                type: type,
                userUuid: localStore.userUuid,
                userName: localStore.name,
                majorUuid: activeFile.majorUuid
            }
            parList.push(par);
        }
        addFileList(projectUuid, parList).then(res => {
            setFiles([...parList, ...files]);
            // setShowFiles([...parList, ...showFiles])
            generateParentData(false)
        }).catch(err => {
            console.log('err', err)
            message.error("创建任务失败");
        })
    }

    /**
     * 打开类型筛选框
     */
    const openTypeFilter = () => {
        const dom = document.getElementById("file-type-head-filter");
        const rect = dom.getBoundingClientRect();
        setTypeFilterMenuLeft(rect.left);
        setTypeFilterMenuTop(rect.top + 32);
        setTypeFilterMenuVisible(true);
    }

    /**
     * 打开执行人筛选框
     */
    const openUserFilter = () => {
        const dom = document.getElementById("file-user-head-filter");
        const rect = dom.getBoundingClientRect();
        setUserFilterMenuLeft(rect.left);
        setUserFilterMenuTop(rect.top + 32);
        setUserFilterMenuVisible(true);
    }

    /**
     * 右键item
     * @param item 
     * @param e 
     */
    const onContextMenuClick = (item: File, e) => {
        setCmLeft(e.clientX);
        setCmTop(e.clientY);
        setCmOpen(true);
        if (!activeList.includes(item.uuid)) {
            setActiveList([item.uuid])
            updateStatus([item.uuid])
        }
    }

    /**
     * 单选逻辑
     */
    const singleSelect = (item: File) => {
        setActiveList([item.uuid])
        updateStatus([item.uuid])
    }

    /**
     * shift选择逻辑
     */
    const shiftSelect = (item: File) => {
        // 若是未选中，则选中0~该item，若是已经选中，则选中选中item到该item之间的所有
        let selectIndex = files.findIndex(i => i.uuid == item.uuid)
        if (activeList?.length < 1) {
            let selectUuidList = []
            for (let i = 0; i < selectIndex + 1; i++) {
                selectUuidList.push(files[i].uuid)
            }
            setActiveList([...selectUuidList])
            updateStatus([...selectUuidList])
        } else {
            let maxIndex = selectIndex
            let minIndex = selectIndex
            for (let i = 0; i < (activeList || []).length; i++) {
                let midIndex = files.findIndex(f => f.uuid == activeList[i])
                if (minIndex > midIndex) {
                    minIndex = midIndex
                }
                if (maxIndex < midIndex) {
                    maxIndex = midIndex
                }
            }
            let selectUuidList = []
            for (let i = minIndex; i <= maxIndex; i++) {
                selectUuidList.push(files[i].uuid)
            }
            setActiveList([...selectUuidList])
            updateStatus([...selectUuidList])
        }
    }

    const ctrlSelect = (item: File) => {
        let midList = activeList
        if (!midList.includes(item.uuid)) {
            midList.push(item.uuid)
        } else {
            midList = midList.filter(i => i != item.uuid)
        }
        setActiveList([...midList])
        updateStatus([...midList])
    }

    /**
     * 点击删除
     */
    const onClickMenuDelete = () => {
        TnModal().deleteModal({
            content: "是否将下级文件全部删除？",
            onOk() {
                TnModal().destoryAll();
                setCmOpen(false);
                // 不允许删除本身文件
                // if (activeList.includes(activeFile.uuid)) {
                //     message.warning("自身物理模型文件需到上一层目录中删除")
                //     return
                // }
                // let deleteList = activeList.filter(item => item != activeFile.uuid)
                deleteFileByUuidList(activeList).then(res => {
                    if (!activeList.includes(activeFile.uuid)) {
                        generateData()
                    }
                }).catch(err => {
                    message.error("删除失败");
                }).finally(() => {
                    let deleteOrigin = activeList.includes(activeFile.uuid) ? true : false
                    generateParentData(deleteOrigin)
                })
            },
            onCancel() {
                TnModal().destoryAll();
                setCmOpen(false);
            },
        });
    }

    /**
     * 下载文件
     * @param file 
     */
    const downLoadFile = (file: File) => {
        if (!file.url) return
        let url = file.url
        fetch(url)
            .then(response => response.blob())  // 将响应转换为 Blob
            .then(blob => {
                // 创建一个临时的 URL 对象
                const downloadUrl = URL.createObjectURL(blob);

                // 创建一个 a 标签并模拟点击
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = file.name || 'download';  // 设置默认下载文件名
                a.click();

                // 释放 URL 对象
                URL.revokeObjectURL(downloadUrl);
            })
            .catch(error => {
                console.error('下载文件失败:', error);
            });
    }

    /**
     * 双击
     */
    const onDoubleClick = (file: File) => {
        // 如果文件是物理模型，不是本目录下的物理模型，打开文件夹
        if (file.type == FileType.MODEL_PHYSICS && file.uuid != activeFile.uuid) {
            setActiveFile(file)
            openFile(file)
            return;
        }
        let majorUuid = file.majorUuid;
        emitter.emit(Emit_Event_Common_Tool.ACTIVE_MAJOR, majorUuid);
        setTimeout(() => {
            navigate(`/projects/${projectUuid}/models/${file.uuid}`)
        }, 0)
    }

    /**
     * 
     * @param index 更新的排序类型在functionList中的index
     * @param functionList 所有的排序useState
     * @param currentSortType 当前的排序类型
     */
    const sortColumn = (index: number, functionList: ((e: number) => void)[], currentSortType: number) => {
        for (let i = 0; i < functionList.length; i++) {
            if (i != index) {
                functionList[i](SortType.NONE)
            }
        }
        if (currentSortType == SortType.NONE) {
            functionList[index](SortType.SORT)
        } else if (currentSortType == SortType.SORT) {
            functionList[index](SortType.REVERSE)
        } else {
            functionList[index](SortType.NONE)
        }
    }

    const onlyGenerateData = () => {
        if (activeFile.type != FileType.MODEL_PHYSICS) {
            findFileListByParentUuidList(projectUuid, props.activeFile?.uuid).then(res => {
                let data: File[] = res.data || [];
                setFiles(data);
            }).catch(err => {
                console.log('err', err)
                message.error("获取文件列表失败");
            })
        } else {
            let fileList: File[] = []
            findFileByUuid(props.activeFile.uuid).then(res => {
                let activeFile: File = res.data
                fileList.push(activeFile)
                return findFileListByParentUuidList(projectUuid, props.activeFile?.uuid)
            }).then(res => {
                let data: File[] = res.data || [];
                fileList.push(...data)
                setFiles(fileList);
            }).catch(err => {
                console.log('err', err)
                message.error("获取文件列表失败");
            })
        }
        generateParentData(false)
    }

    return (
        <>
            <div className="task-table-container">
                <div className="header-row">
                    <div className="head-cell head-cell-name">
                        <span style={{ cursor: "pointer", userSelect: "none" }}
                            onClick={() => {
                                sortColumn(0, [setSortName, setSortUser, setSortTime, setSortSize], sortName)
                            }}>任务</span>
                        {activeFile?.uuid != "project" && <div className="multi-group">
                            <IconButton icon={<CreateSvg />} small onClick={() => { multiCreateFile() }}></IconButton>
                            <Input
                                value={multiCreateNum}
                                onChange={(e) => setMultiCreateNum(e.target.value)}
                                onEnter={multiCreateFile}
                            />
                            <span>个</span>
                        </div>}
                    </div>
                    <div className="head-cell head-cell-user" id="file-user-head-filter">
                        <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => {
                            sortColumn(1, [setSortName, setSortUser, setSortTime, setSortSize], sortUser)
                        }}>
                            执行人
                        </div>
                        <IconButton icon={<FilterSvg />} small style={{ marginLeft: 16 }} onClick={openUserFilter}></IconButton>
                    </div>
                    <div className="head-cell head-cell-type" id="file-type-head-filter" >
                        类型
                        <IconButton icon={<FilterSvg />} small style={{ marginLeft: 16 }} onClick={openTypeFilter}></IconButton>
                    </div>
                    <div className="head-cell head-cell-time"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => {
                            sortColumn(2, [setSortName, setSortUser, setSortTime, setSortSize], sortTime)
                        }}
                    >更新时间</div>
                    <div className="head-cell head-cell-size"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => {
                            sortColumn(3, [setSortName, setSortUser, setSortTime, setSortSize], sortSize)
                        }}
                    >大小</div>
                </div>
                <div className="body">
                    {showFiles?.map((item, key) => (
                        <FileItem
                            key={item.uuid}
                            file={item}
                            active={activeList.includes(item.uuid)}
                            editingUuid={editingUuid}
                            onCtrlSelect={ctrlSelect}
                            onShiftSelect={shiftSelect}
                            onSingleSelect={singleSelect}
                            onContextMenu={(e) => {
                                onContextMenuClick(item, e)
                            }}
                            generateParentData={onlyGenerateData}
                            originFile={activeFile}
                            onDoubleClick={onDoubleClick}
                            onClickDownload={downLoadFile}
                            userOptions={users?.map(item => {
                                return {
                                    value: item.uuid,
                                    label: item.name
                                }
                            })}
                            onFinishEdit={() => setEditingUuid(null)}
                        />
                    ))}
                </div>
            </div>

            {/* 用户筛选弹窗 */}
            <ContextMenuModal
                visible={userFilterMenuVisible}
                left={userFilterMenuLeft}
                top={userFilterMenuTop}
                wrapperClassname='file-file-table-type-context-menu'
                onCancel={() => { setUserFilterMenuVisible(false) }}
            >
                <TabMenuItem
                    active={fileUserFilter.length == users.length}
                    name="全部"
                    onClick={() => {
                        if (fileUserFilter.length == users.length) {
                            setFileUserFilter([])
                        } else {
                            let filterUser = []
                            for (let i = 0; i < users.length; i++) {
                                filterUser.push(users[i].uuid)
                            }
                            setFileUserFilter([...filterUser])
                        }
                    }}
                />
                {users.map((item, key) => (
                    <TabMenuItem
                        key={key}
                        active={fileUserFilter.includes(item.uuid)}
                        name={item.name}
                        onClick={() => {
                            if (fileUserFilter.includes(item.uuid)) {
                                let midFilter = fileUserFilter.filter(i => i != item.uuid)
                                setFileUserFilter([...midFilter])
                            } else {
                                fileUserFilter.push(item.uuid)
                                setFileUserFilter([...fileUserFilter])
                            }
                        }}
                    />
                ))}
            </ContextMenuModal>

            {/* 文件类型筛选弹窗 */}
            <ContextMenuModal
                visible={typeFilterMenuVisible}
                left={typeFilterMenuLeft}
                top={typeFilterMenuTop}
                wrapperClassname='file-file-table-type-context-menu'
                onCancel={() => { setTypeFilterMenuVisible(false) }}
            >
                <TabMenuItem
                    active={fileTypesFilter.length == 6}
                    name="全部"
                    onClick={() => {
                        if (fileTypesFilter.length == 6) {
                            setFileTypesFilter([])
                        } else {
                            setFileTypesFilter([FileType.DRAWING, FileType.IMAGE, FileType.MODEL_FUNCTION, FileType.MODEL_PHYSICS, FileType.REPORT])
                        }
                    }}
                />
                {FileTypeList.map((item, key) => (
                    <TabMenuItem
                        key={key}
                        active={fileTypesFilter.includes(Number(item.value))}
                        name={item.label}
                        onClick={() => {
                            if (fileTypesFilter.includes(Number(item.value))) {
                                let midFilter = fileTypesFilter.filter(i => i != Number(item.value))
                                setFileTypesFilter([...midFilter])
                            } else {
                                fileTypesFilter.push(Number(item.value))
                                setFileTypesFilter([...fileTypesFilter])
                            }
                        }}
                    />
                ))}
            </ContextMenuModal>

            <ContextMenu
                visible={cmOpen}
                top={cmTop}
                left={cmLeft}
                onCancel={() => {
                    setCmOpen(false);

                }}
            >
                <MenuList>
                    <MenuItem>
                        新建任务
                    </MenuItem>
                    {/* <MenuItem>
                        新建文件夹
                    </MenuItem> */}
                    {(activeList || []).length == 1 && <MenuItem onClick={() => {
                        let file = showFiles.find(item => item.uuid == activeList[0])
                        onDoubleClick(file);
                        setCmOpen(false);
                    }}>
                        打开
                    </MenuItem>}
                    {/* <MenuItem >
                        复制
                    </MenuItem> */}
                    {(activeList || []).length == 1 && <MenuItem onClick={() => {
                        let file = showFiles.find(item => item.uuid == activeList[0])
                        setEditingUuid(file.uuid);
                        setCmOpen(false);
                    }}>
                        重命名
                    </MenuItem>}
                    <MenuItem>
                        下载
                    </MenuItem>
                    <MenuItem special onClick={() => {
                        onClickMenuDelete()
                    }}>
                        删除
                    </MenuItem>
                </MenuList>
            </ContextMenu>
        </>
    )
}